const FloatingContact = () => {
  const whatsappMessage = encodeURIComponent('Merhaba, leventatalay.com.tr web siteniz üzerinden yazıyorum.');
  const phoneNumber = '+905324498500';
  const whatsappNumber = '905324498500';

  return (
    <div className="fixed bottom-8 right-8 z-40 flex flex-col gap-3">
      <a
        href={`https://wa.me/${whatsappNumber}?text=${whatsappMessage}`}
        target="_blank"
        rel="noopener noreferrer"
        className="w-14 h-14 bg-green-500 hover:bg-green-600 rounded-full flex items-center justify-center shadow-lg transition-all duration-300 hover:scale-110 cursor-pointer"
        aria-label="WhatsApp ile iletişime geç"
      >
        <i className="ri-whatsapp-line text-white text-2xl"></i>
      </a>
      
      <a
        href={`tel:${phoneNumber}`}
        className="w-14 h-14 bg-dark-gray hover:bg-mid-gray rounded-full flex items-center justify-center shadow-lg transition-all duration-300 hover:scale-110 cursor-pointer"
        aria-label="Telefon ile ara"
      >
        <i className="ri-phone-line text-white text-2xl"></i>
      </a>
    </div>
  );
};

export default FloatingContact;
